import { PlayerDetails } from '../PlayerDetails/PlayerDetails';
import { DetailsWrapper } from '../DetailsWrapper/DetailsWrapper';
import { useContext, useState } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';
import { CheckoutContext } from '@/context/CheckoutContext';
import { TotalPrice } from '../PriceDetails/TotalPrice';
import { cn } from '@/utils/cn';
import { Templates } from '@/types/common';
import {
  DETAILS_STYLES,
  getDetailsContainerStyles,
  getDetailsCollapsibleStyles,
  getDetailsWrapperStyles,
} from '@/constants/styles';
import { MixpanelEvents } from '@/constants/mixpanelEvents';
import { getMixpanelProperties } from '@/utils/mixpanelProperties';
import { mixpanelService } from '@/services/mixpanelService';
import { Divider } from '../Common/Divider';

export const Details = () => {
  const context = useContext(CheckoutContext);
  const { pricing, template, boot } = context;
  const [showPurchedItems, setShowPurchedItems] = useState(template.features.defaultDetailsOpen);
  const isMobile = useIsMobile();
  const templateType = template.type;
  const isOnePayment = templateType === Templates.OnePayment;

  const containerClassName = cn(DETAILS_STYLES.base, getDetailsContainerStyles(templateType));

  const collapsibleClassName = getDetailsCollapsibleStyles(templateType, showPurchedItems);
  const wrapperClassName = getDetailsWrapperStyles(templateType, isMobile);

  const handleShowPurchasedItems = () => {
    setShowPurchedItems(!showPurchedItems);
    const properties = getMixpanelProperties(context);
    mixpanelService.track(MixpanelEvents.CHECKOUT_SECTION_STATE_CHANGED, {
      ...(properties as Record<string, unknown>),
      type: showPurchedItems ? 'expanded' : 'collapsed',
    });
  };
  const renderContent = () => {
    if (isOnePayment) {
      return (
        <div className="flex flex-col w-full pb-2">
          <div data-testid="one-payment-details-wrapper" className={collapsibleClassName}>
            <DetailsWrapper />
          </div>
          <TotalPrice pricing={pricing} />
          <div className="flex flex-col w-full mt-3">
            <Divider />
          </div>
        </div>
      );
    }

    if (!isMobile) {
      return (
        <div className={wrapperClassName}>
          <DetailsWrapper />
          <TotalPrice pricing={pricing} />
        </div>
      );
    }

    return (
      <div className="mb-3">
        <div data-testid="mobile-details-wrapper" className={collapsibleClassName}>
          <DetailsWrapper />
        </div>
        <TotalPrice pricing={pricing} />
      </div>
    );
  };

  return (
    <div
      data-testid="details-section"
      className={`${containerClassName} ${isOnePayment && 'text-card-foreground'}`}
      style={{
        color: !isOnePayment ? boot?.checkoutTheme?.textColor : undefined,
      }}
    >
      <PlayerDetails showPurchedItems={showPurchedItems} handleShowPurchedItems={() => handleShowPurchasedItems()} />
      {renderContent()}
    </div>
  );
};
